/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import InvoiceItem from "components/invoices/InvoiceItem";
import { Trans } from "react-i18next";

class InvoicesTable extends Component {
  state = {
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  trType = "";
  trName = "";
  employee = "";
  trDuration = "";
  trStatus = "";
  trDailyPrice = "";
  trTotalPrice = "";
  trStartDate = "";
  trEndDate = "";
  trGroup = "";
  invoiceTotal = "";
  invoiceVat = "";
  invoiceBeforeVat = "";
  trAttendance ="";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.employee = "";
    this.trStatus = "";
    this.trDailyPrice = "";
    this.trDuration = "";
    this.trTotalPrice = "";
    this.trStartDate = "";
    this.trEndDate = "";
    this.trGroup = "";
    this.invoiceTotal = "";
    this.invoiceVat = "";
    this.invoiceBeforeVat = "";
    this.trAttendance = "";

    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "employee":
        this.employee = `_${this.state.sort_dir}`;
        break;
      case "trDuration":
        this.trDuration = `_${this.state.sort_dir}`;
        break;
      case "trStatus":
        this.trStatus = `_${this.state.sort_dir}`;
        break;
      case "trDailyPrice":
        this.trDailyPrice = `_${this.state.sort_dir}`;
        break;
      case "trTotalPrice":
        this.trTotalPrice = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      case "trGroup":
        this.trGroup = `_${this.state.sort_dir}`;
        break;
      case "invoiceTotal":
        this.invoiceTotal = `_${this.state.sort_dir}`;
        break;
      case "invoiceVat":
        this.invoiceVat = `_${this.state.sort_dir}`;
        break;
      case "invoiceBeforeVat":
        this.invoiceBeforeVat = `_${this.state.sort_dir}`;
        break;
      case "trAttendance":
        this.trAttendance = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {
    const sorted = this.props.data.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "employee":
          return this.state.sort_dir === "desc"
            ? a.employee.name.localeCompare(b.employee.name)
            : b.employee.name.localeCompare(a.employee.name);
        case "trDuration":
          return this.state.sort_dir === "desc"
            ? a.duration - b.duration
            : b.duration - a.duration;
        case "trStatus":
          return this.state.sort_dir === "desc"
            ? a.successful - b.successful
            : b.successful - a.successful;
        case "trStartDate":
          return this.state.sort_dir === "desc"
            ? a.startDate - b.startDate
            : b.startDate - a.startDate;
        case "trEndDate":
          return this.state.sort_dir === "desc"
            ? a.endDate - b.endDate
            : b.endDate - a.endDate;
        case "trTotalPrice":
          return this.state.sort_dir === "desc"
            ? a.pricePerDay * a.duration - b.pricePerDay * b.duration
            : b.pricePerDay * b.duration - a.pricePerDay * a.duration;
        case "trDailyPrice":
          return this.state.sort_dir === "desc"
            ? a.pricePerDay - b.pricePerDay
            : b.pricePerDay - a.pricePerDay;
        case "trGroup":
          return this.state.sort_dir === "desc"
            ? a.group - b.group
            : b.group - a.group;
        case "trAttendance":
          return this.state.sort_dir === "desc"
            ? a.attendanceOutcome - b.attendanceOutcome
            : b.attendanceOutcome - a.attendanceOutcome;
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
    });

    return sorted.map((t) => {
      return <InvoiceItem key={t.key} inv={t} />;
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive tgE dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("trType")}
                className={`all sorting${this.trType}`}
              >
                <div className="tableTitle">
                  <Trans desc="Tür">10114</Trans>
                </div>
              </th>
              <th
                onClick={() => this.reOrder("trName")}
                className={`all sorting${this.trName}`}
              >
                <div className="tableTitle">
                  <Trans desc="Eğitim Adı">10115</Trans>
                </div>
              </th>
              <DesktopBreakpoint>
                <th
                  onClick={() => this.reOrder("employee")}
                  className={`desktop sorting${this.employee}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Alan">10116</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trStartDate")}
                  className={`desktop sorting${this.trStartDate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10117</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trEndDate")}
                  className={`desktop sorting${this.trEndDate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10118</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trGroup")}
                  className={`desktop sorting${this.trGroup}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Grup">10119</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trAttendance")}
                  className={`desktop sorting${this.trAttendance}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Katılım">10522</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trStatus")}
                  className={`desktop sorting${this.trStatus}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Başarı">10120</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trDuration")}
                  className={`desktop sorting${this.trDuration}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Gün">10121</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trDailyPrice")}
                  className={`desktop sorting${this.trDailyPrice}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Günlük">10122</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trTotalPrice")}
                  className={`desktop sorting${this.trTotalPrice}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Toplam">10123</Trans>
                  </div>
                </th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>
            {this.renderData()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default InvoicesTable;
